import { CreditNoteDto } from '@api';

export const CREDIT_NOTES: CreditNoteDto[] = [];
